import React from "react";
import { Card, Table } from "antd";
import dayjs from "dayjs";
import { convertUtcToIst } from "../../../helpers/utility";
import {
  TIME_SORT_DIRECTIONS,
  makeTimeSorter,
} from "../../../helpers/timeSorter";

const VitalsTable = ({ data }) => {
  const columns = [
    {
      title: "Time Done",
      dataIndex: "action_time",
      key: "action_time",
      sorter: makeTimeSorter("action_time"),
      sortDirections: TIME_SORT_DIRECTIONS,
      render: (value) => convertUtcToIst(value, true, true),
    },
    { title: "Temperature", dataIndex: "temperature", key: "temperature" },
    { title: "Pulse Rate", dataIndex: "pulse", key: "pulse" },
    { title: "Respiratory Rate", dataIndex: "respiration", key: "respiration" },
    { title: "Spo2", dataIndex: "oxygen_saturation", key: "oxygen_saturation" },
    {
      title: "Systolic BP",
      dataIndex: "systolic_pressure",
      key: "systolic_pressure",
    },
    {
      title: "Diastolic BP Rate",
      dataIndex: "diastolic_pressure",
      key: "diastolic_pressure",
    },
    // {
    //   title: "Remarks",
    //   dataIndex: "remarks",
    //   key: "remarks",
    // },
    {
      title: "Processed By",
      dataIndex: "processed_by_name",
      key: "processed_by_name",
    },
  ];
  return <Table columns={columns} dataSource={data} pagination={false} bordered={false} style={{ background: "transparent",   border: "none",}}showHeader={true}/>;
};

export default VitalsTable;
